import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStethoscope } from "@fortawesome/pro-regular-svg-icons";
import { formatDateTime } from "@/utils/format";
import { getEncounterTypeLabel } from "../encounter-utils";
/** Banner shown in the add-document flow naming the encounter being appended to. */
export function EncounterContextBanner(_ref) {
  var encounter = _ref.encounter;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 rounded-sds-200 border border-sds-base-default bg-sds-base-secondary px-4 py-3 text-style-body-small text-sds-base-secondary"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faStethoscope,
    className: "h-4 w-4 shrink-0 icon-sds-brand-default"
  }), /*#__PURE__*/React.createElement("span", null, t("adding_to", {
    defaultValue: "Adding to"
  }), " ", /*#__PURE__*/React.createElement("span", {
    className: "text-sds-base-default"
  }, getEncounterTypeLabel(encounter.encounter_type)), " ", "\xB7 ", formatDateTime(encounter.start_date)));
}